/* istanbul ignore file */
export class ParamConstructor {
    construct(field: string, value: any): string {
        if (value != null) {
            return field + '=' + value;
        }

        return '';
    }
}
